module.exports = __webpack_public_path__ + "static/media/wodonga-tafe.ea859598.jpg";